import { render, staticRenderFns } from "./extrafield-assignments.vue?vue&type=template&id=77efa31a"
import script from "./extrafield-assignments.vue?vue&type=script&lang=js"
export * from "./extrafield-assignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports